import { render, staticRenderFns } from "./SubscriptionBox.vue?vue&type=template&id=523006de&"
import script from "./SubscriptionBox.vue?vue&type=script&lang=js&"
export * from "./SubscriptionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports